// extracted by mini-css-extract-plugin
export default {"page":"jr-z","landingBackground":"kr-z","nonLandingBackground":"lr-z"};